<template>
  <div v-if="(loading || (yoData && !hideDetail))">
    <h2 class="primary--text body-2" >{{title}}</h2>
    <v-progress-linear v-if="loading" indeterminate color="primary" class="my-0"></v-progress-linear>
    <template>
      <table class="mrs-tbl" cellspacing="0"  v-if="nmeaConfig.col1.length > 0">
        <thead>
          <tr>          
            <td v-for="col in col1" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
          </tr>
        </thead>
        <tr>          
            <td v-for="col in col1" :key="`td_${col.name}`">{{dataFromYo(col.name,col.offsetYoForPlot)}}</td>        
        </tr>
      </table> 
      <table class="mrs-tbl mt-1" cellspacing="0"  v-if="nmeaConfig.col2.length > 0">
        <thead>
          <tr>          
            <td v-for="col in col2" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
          </tr>
        </thead>
        <tr>          
            <td v-for="col in col2" :key="`td_${col.name}`">{{dataFromYo(col.name,col.offsetYoForPlot)}}</td>        
        </tr>
      </table> 
      <table class="mrs-tbl mt-1" cellspacing="0"  v-if="nmeaConfig.col3.length > 0">
        <thead>
          <tr>          
            <td v-for="col in col3" :key="`th_${col.name}`">{{$i18n.locale == 'fr'?col.libelleFr||col.libelleEn:col.libelleEn||col.libelleFr}} <template v-if="col.unit.length > 0">[{{col.unit}}]</template></td>            
          </tr>
        </thead>
        <tr>          
            <td v-for="col in col3" :key="`td_${col.name}`">{{dataFromYo(col.name,col.offsetYoForPlot)}}</td>        
        </tr>
      </table> 
    </template>  
  </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloMission } from '../../models/alo/AloMission';
import { NmeaConfig, mustHideIfOlderThanMrs } from '@/models/datapool/NmeaConfig'
import { toStringDictionary } from '@/utils/groupBy'
import { mustIgnoreValue } from '@/utils/autoscale';

@Component({
  name: 'MissionNmeaDetail' ,
  props:{
     mission:{
      type: AloMission
    }, 
    nmeaConfig:{
      type:NmeaConfig
    },
    loading:{
      type:Boolean,
      default:false
    },
    yoCycle:{
      type:Number,
      default:0
    },
    yoIndex:{
      type:Number,
      default:0
    }
  }
})
export default class MissionNmeaDetail extends Vue {
    
  mission!:AloMission  
  nmeaConfig!:NmeaConfig
  yoCycle!:number
  yoIndex!:number
  loading!:boolean

  getNextYo(val:number,decalage:number = 1){    
        let yo = decalage==0?this.mission?.yoArray[val]:null
        let offset = 1
        //on prend la valeur absolue du décalage
        decalage = Math.abs(decalage)  
        while(decalage > 0) {
          while(this.mission?.yoArray?.length > (val+offset) &&  (yo = this.mission?.yoArray[val+offset])?.isUnderWater){
            offset++;
          }                
          decalage--;  
        }
        if(yo && !yo?.isUnderWater) return yo?.yosCycle  
        else return null         
    }

  dataFromYo(name:string,decalage:number = 0){    

    const header = this.dicHeader[name.toLowerCase()] 
    const yoData = decalage==0?this.yoData:this.dataNmea.dataSet[this.getNextYo(this.yoIndex,decalage)!]    

    const val = (yoData && !mustIgnoreValue(yoData[header.pos]))?yoData[header.pos] : "-"
    //le 0.1 est une fausse lat ou lng qui génre bien une lettre pour la conversion
    //@ts-ignore
    if(header?.dbName?.endsWith('_LAT')) return val=="-"?val:this.$options.filters[this.coordFormatFilter]([0.1,val],true)
    //@ts-ignore
    else if(header?.dbName?.endsWith('_LON')) return val=="-"?val:this.$options.filters[this.coordFormatFilter]([val,0.1],false);
    //@ts-ignore
    else return header?.dbTypeName == "datetime2"?val=="-"?val:this.$options.filters.formatDate(val,"DD/MM/YYYY HH:mm:ss UTC"):val
  }

  
  //Désactivation du tableau au rafraîchissement si la trame n'est plus présente (option `hideIfOlderThanMrs` de la trame,
  //par défaut SEAWPT, SEADRF, SEATRK, SEAFLT, SEABTM, SEADEV, SEAALR - BUG-082)
  //on désactive si la date de la trame est inférieur à la date de la trame SEAMRS
  get hideDetail() {    
    if(mustHideIfOlderThanMrs(this.nmeaConfig)) {
      const datMrpsColPos = this.mission?.dataNmea['seamrs']?.columns?.find(c => c.dbName.toLocaleLowerCase() == 'trm_dattrm')?.pos ?? -1
      if(datMrpsColPos > -1) {      
        const datMrs =  this.mission?.dataNmea['seamrs']?.dataSet[this.yoCycle][datMrpsColPos]
        const datTrm = this.yoData[this.dicHeader['trm_dattrm'].pos]
        if(datMrs){
          return datTrm?datMrs>datTrm:true
        }
      }
    }
    return false        
  }

  get title(){
    return this.nmeaConfig?.name?.indexOf('sea') == 0?this.nmeaConfig?.name?.substring(3)?.toUpperCase():this.nmeaConfig?.name?.toUpperCase()
  }
  
  get coordFormatFilter(){
    return this.$store.myGetters.coordFormatFilter
  }

  get yoData(){
    return this.dataNmea?.dataSet && this.dataNmea?.dataSet[this.yoCycle]
  }

  get dataNmea() {
    return this.mission?.dataNmea[this.nmeaConfig.name.toLowerCase()]
  }

  get dicHeader(){
    return this.dataNmea?toStringDictionary(this.dataNmea?.columns ?? [],key => key?.dbName?.toLowerCase()):{}
  }

  get col1(){
    return this.nmeaConfig?.col1?.filter(c => !!this.dicHeader[c?.name?.toLowerCase()])
  }

  get col2(){
    return this.nmeaConfig?.col2?.filter(c => !!this.dicHeader[c?.name?.toLowerCase()])
  }

  get col3(){
    return this.nmeaConfig?.col3?.filter(c => !!this.dicHeader[c?.name?.toLowerCase()])
  }

}
</script>

<style scope>
  .cursor-pointer{
  cursor: pointer;
}
</style>